module.exports = __webpack_public_path__ + "static/media/CP09_TRISET_DEFLECTION.b10c490a.png";